import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import AppManager from "../../managers/AppManager";
import RouteManager from "../../managers/RouteManager";
import {
    DKLabel,
    DKButton,
    showToast,
    TOAST_TYPE,
    DKIcons
} from "deskera-ui-library";
import { useTranslation } from "react-i18next";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import PerformaceService from "../../services/PerformaceService";
import CreateGoal from "./CreateGoal";
import { goalsDataUpdateBeforeDisplay, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import Utility, { deepClone } from "../../utility/Utility";
import { fetchUsers, selectUsers } from "../../Redux/Slices/PayrollSlice";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../common/Popup";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { COMPANY_DATE_FORMATS } from "../../constants/Constant";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

export default function Goals(props) {
    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    const [goalAPIConfig,setAPIConfig] = useState({
        limit: 20,
        page: 0,
        search: '',
        sort: 'createdAt',
        sortDir: 'desc'
    })
    
    //State hooks
    const [gridData, setGridData] = useState(initialState);
    const [filterArray, setFilterArray] = useState([]);
    const [currentPage, setCurrentPage] = useState(goalAPIConfig.page);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [goalPopup, setGoalPopup] = useState({
        visibility: false,
        data:null
    })
    const [applicableToPopup, setApplicableToPopup] = useState(null)
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const users = useSelector(selectUsers);
    const isAdminOrManager = TenantService.get(TENANT.IS_ADMIN) || TenantService.get(TENANT.IS_MANAGER) ? true : false;
    const isManager = TenantService.get(TENANT.IS_MANAGER) && !TenantService.get(TENANT.IS_ADMIN)
    let dateFormat = COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))
    dateFormat = dateFormat[0]?.value;

    useEffect(() => {
        setGridData({
            ...gridData,
            columnData:parseVisibleColumnConfig(
                parseColumnConfig(TableManger.getTableColumns(TABLES.PEOPLE_PERFORMANCE_GOAL) )
              ),
            rowData:[]
        })
        window.viewApplicableTo=(data)=>{
            
            setApplicableToPopup(Utility.decodeJSON(data))
        }
        getGoals(goalAPIConfig);
        if(PermissionUtils.hasAccess(MODULE.PERFORMANCE_GOAL, [ACTION.VIEW, ACTION.CREATE, ACTION.DELETE])) {
            getUsers();
        }
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();
        return () => {
            window.viewApplicableTo = null;
        }
    }, []);
    // API calls
    const getGoals = (config) => {
        setAPIConfig(config);
        PerformaceService.getGoals(config).then(res => {
            if (res && res.content) {
                setGridData({
                    ...gridData,
                    columnData:parseVisibleColumnConfig(
                        parseColumnConfig(TableManger.getTableColumns(TABLES.PEOPLE_PERFORMANCE_GOAL) )
                      ),
                    rowData: goalsDataUpdateBeforeDisplay(res.content)
                })
                setTotalPageCount(res.totalPages);
                setCurrentPage(res.pageable.pageNumber+1);
                // setTotalCount(res.totalElements)
            }
        }, error => {
            console.log(error);
        })
    }
    const getUsers = async () => {
        await dispatch(fetchUsers())
    }
    // grid function
    const onRowDelete = (data) => {
        let param = {
            ids:[]
        }
        let createdBy = [];
        if(data.rowData) {
            param.ids.push(data.rowData.id)
            createdBy.push(data.rowData.createdBy);
        } else if(data?.length>0) {
            param.ids = data.map(d=>d.id)
            createdBy = data.map(d=>d.createdBy)
        }
        if(isManager) {
            const iam = TenantService.get(TENANT.IAM_USER_ID);
            const ind = createdBy?.findIndex(c=>c != iam);
            if(ind !== -1) {
                showToast('You have only allowed to delete self-created Goals.');
                return
            }
        }
        
        PerformaceService.deleteGoals(param).then(res=>{
            showToast('Goal deleted succesfully',TOAST_TYPE.SUCCESS);
            getGoals(goalAPIConfig);
        },error=>{
            if(error?.errorMessage) {
                showToast(error.errorMessage,TOAST_TYPE.FAILURE);
            } else {
                showToast('Something went wrong while deleting goal',TOAST_TYPE.FAILURE);
            }
            getGoals(goalAPIConfig);
        })
     }
    const onRowEdit = (data) => {
        setGoalPopup({
            ...goalPopup,
            visibility:true,
            data:deepClone(data.rowData.originalRow)
        })
    }
    const onContextCancel = () => {
        getGoals({
            ...goalAPIConfig
        })
     }
    const onCreateNew = () => { 
        setGoalPopup({
            ...goalPopup,
            visibility:true,
            data:null
        })
    }
    const onSort = () => { }
    const onSearch = (value) => {
        getGoals({
            ...goalAPIConfig,
            search: value
        });
    }
    const onColumnRowUpdate = () => { }
    const onFilter = () => { }
    const onRowAdd = (newRow) => { }
    const onClosePopup = (refresh) =>{
        if(refresh) {
            getGoals(goalAPIConfig);
        }
        setGoalPopup({
            ...goalPopup,
            visibility:false,
            data:null
        })
    }

    const getEmployeeName = (iamUserId) => {
        const userList = users?.users
        if(userList ) {
            const userObj = userList.find(u=>parseInt(u.iamUserId) === iamUserId);
            return `${userObj?.firstName} ${userObj?.lastName}`
        } else {
            return ''
        }
    }

    // UI renderer
    const getApplicableToPopup = () =>{
        let applicableToColumn = ``;
    if(!Utility.isEmpty(applicableToPopup?.applicability?.designation)) {
        applicableToColumn = `Designation: ${applicableToPopup?.applicability?.designation} `
    } else if(!Utility.isEmpty(applicableToPopup?.applicability?.teamId)) {
        applicableToColumn = `Team: ${applicableToPopup?.applicability?.teamName}`
    } else {
        applicableToColumn = (applicableToPopup?.applicability?.users?.length>1) ? 
        `${applicableToPopup.applicability?.users?.length} ${applicableToPopup?.applicability?.users?.length>1 ?"users":"user"}</text>`
        :``
    }
        return (
            <>
                <Popup className="" >
                    <div className="row justify-content-between">
                        <DKLabel className="fw-m fs-m" text={`Applicable To ${applicableToColumn}`}/>
                        <DKButton className="" icon={DKIcons.ic_close} title="" onClick={()=>setApplicableToPopup(null)}/>
                    </div>
                    <div className="">
                        <ol>
                        {applicableToPopup.applicability.users.map(iamUserId=>{
                            return <li className="p-v-xs">{getEmployeeName(iamUserId)}</li>
                        })}
                        </ol>
                    </div>
                </Popup>
            </>
        )
    }
    return (
        <>
            {/* <DKLabel className="fw-m fs-l" text="Goals" /> */}
            <div className="column parent-width flex-1">
                <div className="column parent-width mb-s position-relative flex-1">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_PERFORMANCE_GOAL}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_PERFORMANCE_GOAL]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        onRowDelete={onRowDelete}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        onCancelContext={() => {
                            onContextCancel();
                        }}
                        addButtonConfig={PermissionUtils.hasAccess(MODULE.PERFORMANCE_GOAL, ACTION.CREATE) ? [{
                            title: "+ Create Goal",
                            className: "bg-app text-white ml-s",
                            onClick: () => onCreateNew(),
                        }]:[]}
                        
                        gridData={gridData}
                        onSearch={onSearch}
                        onFilter={onFilter}
                        filter={filterArray}
                        onRowAdd={onRowAdd}
                        onPaginationClick={(requestedPageNumber) => {
                            getGoals({
                                ...goalAPIConfig,
                                page: requestedPageNumber - 1
                            });
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={PermissionUtils.hasAccess(MODULE.PERFORMANCE_GOAL, [ACTION.EDIT, ACTION.DELETE])}
                        contextMenu={PermissionUtils.hasAccess(MODULE.PERFORMANCE_GOAL, ACTION.DELETE)}
                        isMenuVisible={PermissionUtils.hasAccess(MODULE.PERFORMANCE_GOAL, ACTION.DELETE)}
                        allowRowEdit={false}
                        onSort={(data) => { onSort(data) }}
                        onRowUpdate={(data) => { onColumnRowUpdate(data) }}
                        onRowOpenBtnHidden={false}
                        showContextEdit={false}
                        dateFormat={dateFormat}
                        onColumnShift={()=>{ onContextCancel() }}
                        module={MODULE.PERFORMANCE_GOAL}
                    />
                </div>
            </div>
            {goalPopup.visibility && <CreateGoal data={goalPopup.data} onClose={(isRefresh)=>onClosePopup(isRefresh)}/>}
            {applicableToPopup && getApplicableToPopup()}
        </>
    )
}